module.exports = __webpack_public_path__ + "static/baby-1-585dd125abdd6c7541326f7aa0d9f6a5.jpg";